'use strict';
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this_1 = this;
exports.__esModule = true;
require('../../css/workbench.css');
var tree_logic_1 = require("workbenchRoot/widgets/navigation/tree/app/js/logic/tree-logic");
var tree_maker_1 = require("workbenchRoot/widgets/navigation/tree/app/js/logic/tree-maker");
var some_logic_1 = require("../logic/some-logic");
var broadcast_config_1 = require("../../../../../widgets/navigation/report-options2/broadcast-config");
var report_options_component_1 = require("workbenchRoot/widgets/navigation/report-options2/report-options.component");
var global_tables_component_1 = require("../../../../../widgets/management/global-tables/global-tables.component");
var address_book_component_1 = require("../../../../../widgets/management/address-book2/address-book.component");
var angular = require("angular");
var EMPTY_REPORT_OPTIONS = btoa('{}');
/**
 * This is the Chomolongma workbench.
 *
 * This controller handles all api calls. Maybe we need to move them
 * in order to decouple the modules?
 *
 * For now, tree widget is highly depended on astro, or say call the
 * api from this controller. Also navbar and menu.
 */
angular.module('smartorg.r6.views.workbench', [
    'ngRoute',
    'neatLayoutModule',
    "rx",
    require('workbenchRoot/components/share-link/app/js/plumbing/app'),
    require('workbenchRoot/widgets/navigation/navbar/app/js/plumbing/app'),
    require('workbenchRoot/widgets/navigation/menu/app/js/plumbing/app'),
    require('workbenchRoot/widgets/navigation/report-options/app/js/plumbing/app'),
    require('workbenchRoot/widgets/navigation/tree/app/js/plumbing/app'),
    require('workbenchRoot/widgets/navigation/workspace/app/js/plumbing/app'),
    report_options_component_1["default"],
    // require('workbenchRoot/widgets/management/address-book/app/js/plumbing/app'),
    address_book_component_1["default"],
    require('workbenchRoot/widgets/management/group-manage/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/user-profile/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/define-category/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/assign-category/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/calculation-engine-log/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/legal-message/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/broadcast-messages/app/js/plumbing/component'),
    require('workbenchRoot/widgets/management/pypeer-log/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/create-portfolio/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/create-portfolio-from-existing/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/archive-portfolio-from-existing/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/import-portfolio/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/portfolio-permissions/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/restrict/app/js/plumbing/app'),
    require('workbenchRoot/widgets/management/broadcast-messages-view/app/js/plumbing/component'),
    require('workbenchRoot/widgets/management/portfolio-configuration/app/js/plumbing/app'),
    global_tables_component_1["default"],
]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/workbench', {
            template: require('../../template/wb-3-panels.html'),
            controller: 'WorkbenchCtrl',
            reloadOnSearch: false
        });
    }]).controller('WorkbenchCtrl', [
    '$scope', '$location', '$timeout', 'config', 'versionlog', 'shareLink', 'rx', '$rootScope', '$cookies',
    function ($scope, $location, $timeout, config, versionlog, shareLink, rx, $rootScope, $cookies) {
        var smartorgApi = config.smartorg;
        // Load querystring by $location.search, got a json object.
        // let params = $location.search();
        $scope.astro = smartorgApi;
        $scope.astro.protocols.credentials = {};
        // console.log(smartorg);
        $scope.versionLog = versionlog;
        $scope.command = "EMPTY_PAGE";
        $scope.alertType = "";
        $scope.portfolioData = [];
        setTimeout(function () {
            getCalculationEngineInfo();
        }, 0);
        // Get calc engine info
        var getCalculationEngineInfo = function () {
            smartorgApi.getCalculationEngineInfo().then(function (rs) {
                $scope.calcEngineState = rs;
            })["catch"](function (err) {
                console.error(err);
            });
        };
        $scope.switchPan = function (key) {
            var target = "/workbench";
            if (key == '2') {
                target = "/workbench-2";
            }
            else if (key == '3') {
                target = "/workbench-3";
            }
            var search = $location.search();
            $location.path(target).search(search);
        };
        $scope.loadPortfolio = function () {
            /**
             * Load portfolio. That's it.
             */
            smartorgApi.portfolios().then(function (data) {
                var portfolios = data.portfolios;
                for (var i = 0; i < portfolios.length; i++) {
                    $scope.portfolioData.push({ text: portfolios[i].name.trim() });
                }
                $scope.$apply();
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, "Failed to load portfolios.");
            });
        };
        function logoutWorkbench() {
            shareLink.clearTreeFilters();
            shareLink.clearTreeExcludeFilters();
            clearInterval(intervalHandle);
            $scope.astro.protocols.logout();
            $location.path('/login');
        }
        $scope.timeoutModal = {
            id: "timeoutModal",
            title: "",
            message: "",
            showStayButton: true,
            refresh: function () {
                smartorgApi.authenticateThroughToken()["catch"](function (err) {
                    $scope.showAlert('danger', err.status, err.message);
                });
            },
            logout: function () {
                $timeout(function () {
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    logoutWorkbench();
                });
            },
            show: function () {
                var modal = $('#' + $scope.timeoutModal.id);
                if (!modal.is(':visible')) {
                    modal.modal({ backdrop: 'static', keyboard: false });
                }
            },
            hide: function () {
                $('#' + $scope.timeoutModal.id).modal('hide');
            }
        };
        var intervalHandle = setInterval(function () {
            var tokenTime = $cookies.get('smartorg_api_jwt_time') || 1;
            var timeSpan = new Date().getTime() - tokenTime;
            if (timeSpan > 1790000) {
                // 30 minutes
                $scope.timeoutModal.title = "Your session has timed out!";
                $scope.timeoutModal.message = "Please log in again.";
                $scope.timeoutModal.showStayButton = false;
                $timeout($scope.timeoutModal.show);
                clearInterval(intervalHandle);
            }
            else if (timeSpan > 1620000) {
                // At 27 minutes
                $scope.timeoutModal.title = "Your session is about to time out!";
                $scope.timeoutModal.message =
                    "You will be logged out in " +
                        Math.ceil((1800000 - timeSpan) / 60000) +
                        " minutes. " +
                        "Please take action.";
                $scope.timeoutModal.showStayButton = true;
                $timeout($scope.timeoutModal.show);
            }
        }, 10000);
        // Handle input screen and table input unsaved stuff.
        window.onbeforeunload = function (e) {
            if ($rootScope.smartorgDirty) {
                var dialogText = 'Do you want to leave this site? Changes you made may not be saved';
                e.returnValue = dialogText;
                return dialogText;
            }
            else {
                return undefined;
            }
        };
        window.onunload = function (e) {
            clearInterval(intervalHandle);
        };
        // ============================================
        // Default UI and Toggle Panels
        // ============================================
        /**
         * Show home page. Currently it is set to show description.
         */
        $scope.showHomePage = function () {
            $scope.showDescription();
        };
        $scope.triggers = {
            left: document.getElementsByName('splitterPrev')[0],
            right: document.getElementsByName('splitterAfter')[1]
        };
        /**
         * Set the initial state of left/right panel display.
         *
         * @type {{top: boolean, right: boolean, left: boolean, bottom: boolean}}
         */
        $scope.layoutCollapsed = {
            top: true,
            right: false,
            left: false,
            bottom: false
        };
        /**
         * Show first pan by default. Set to first to show first
         * panel. Set to undefined hide the whole action panel.
         *
         * @type {string}
         */
        $scope.activePanel = 'first';
        /**
         * Toggle a panel collapse or expand.
         *
         * @param panel {string} Which panel the button is on. Key
         *     words are: top, left, right, bottom.
         */
        $scope.togglePanel = function (panel) {
            $scope.layoutCollapsed[panel] = !$scope.layoutCollapsed[panel];
            $scope.layoutUpdate(panel, $scope.layoutCollapsed[panel]);
        };
        $scope.expandPanel = function (panel) {
            if ($scope.layoutCollapsed[panel]) {
                $scope.togglePanelByHacking(panel);
            }
            $scope.activePanel = 'first';
            $scope.layoutCollapsed[panel] = false;
            $scope.layoutUpdate(panel, false);
        };
        $scope.collapsePanel = function (panel) {
            if (!$scope.layoutCollapsed[panel]) {
                $scope.togglePanelByHacking(panel);
            }
            $scope.activePanel = undefined;
            $scope.layoutCollapsed[panel] = true;
            $scope.layoutUpdate(panel, true);
        };
        $scope.togglePanelByHacking = function (panel) {
            setTimeout(function () {
                if ($scope.triggers[panel]) {
                    $scope.triggers[panel].click();
                }
            });
        };
        /**
         * Hide all the panels (left, right, bottom. Even when
         * they are collapsed.
         */
        $scope.hidePanels = function () {
            $scope.collapsePanel('left');
            $scope.hideAllPanels = true;
        };
        /**
         * Show panels if they are currently hidden.
         */
        $scope.showPanels = function () {
            $scope.expandPanel('left');
            $scope.hideAllPanels = false;
        };
        /**
         * Go back to the last action menu item. If there is no
         * item selected, show empty page.
         */
        $scope.backtoAction = function () {
            if ($scope.selected) {
                $scope.onSelectNode($scope.selected._id);
            }
            else {
                $scope.command = 'EMPTY_PAGE';
            }
        };
        /**
         * Set leftleft panel highlight status.
         * @param key {string} Button key.
         * @param panel {string} Which panel the button is on. Key
         *     words are: top, left, right, bottom.
         */
        $scope.setActivePanel = function (key, panel) {
            var checkCollapse = $scope.layoutCollapsed[panel];
            if ($scope.activePanel == key) {
                $scope.activePanel = undefined;
                $scope.layoutCollapsed[panel] = true;
            }
            else {
                $scope.activePanel = key;
                $scope.layoutCollapsed[panel] = false;
            }
            $scope.layoutUpdate(panel, $scope.layoutCollapsed[panel]);
            if (checkCollapse != $scope.layoutCollapsed[panel]) {
                $scope.togglePanelByHacking(panel);
            }
        };
        /**
         * Let all children (widget) know if a panel is collapsed
         * or expanded.
         *
         * @param panel {string} Key is the properties of
         *     layoutCollapsed;
         * @param collapsed {boolean} True is collapsed. False
         *     is expanded.
         */
        $scope.layoutUpdate = function (panel, collapsed) {
            $scope.$broadcast('workbench:toggle-collapse:' + panel, {
                collapsed: collapsed
            });
            $scope.$broadcast('workbench:toggle_collapse', {
                status: $scope.layoutCollapsed
            });
        };
        /**
         * New panel control will not trigger panel update event.
         * So create a watch to handle it.
         */
        $scope.$watch('layoutCollapsed.left', function (newVal) {
            $scope.layoutUpdate('left', newVal);
        });
        $scope.$watch('layoutCollapsed.right', function (newVal) {
            $scope.layoutUpdate('right', newVal);
        });
        $scope.$watch('selected', function (newVal) {
            if (newVal) {
                var path = [newVal.name];
                var tmpTree = newVal;
                while (tmpTree.parent) {
                    path.push(tmpTree.parent.name);
                    tmpTree = tmpTree.parent;
                }
                $scope.leftCrumb = path.reverse().join(" > ");
            }
            else {
                $scope.leftCrumb = "Navigation";
            }
        });
        $scope.$watch('selectedMenuItem', function (newMenu) {
            if (newMenu) {
                $scope.rightCrumb = newMenu.displayText;
            }
            else {
                $scope.rightCrumb = "Action";
            }
        });
        // ============================================
        // Navigation Actions
        // ============================================
        /** Select portfolio, load left panel tree widget.
         *
         * @param {string} treeID The tree id is the same as portfolio
         *     name.
         *
         * @param params {{}} Query string object. Including tree
         *     id (portfolio), selected tree node id (treenode),
         *     and selected menu id (menu). Undefined means this
         *     is from selecting portfolio.
         */
        $scope.onSelectPortfolio = function (treeID, params) {
            if (params && params["portfolio"]) {
                treeID = params["portfolio"];
            }
            else {
                shareLink.clearAll();
            }
            if (treeID) {
                $scope.showPanels();
                // Check user group permissions
                $scope.expandPanel('left');
                shareLink.setValue('portfolio', treeID);
                $scope.initManage();
                $scope.initTree(treeID, params);
                // Disable compare.
                // Maybe should replace it with a clear up function?
                $scope.reportOptionString = EMPTY_REPORT_OPTIONS;
                if (params && 'options' in params) {
                    $scope.reportOptionString = params['options'] || EMPTY_REPORT_OPTIONS;
                }
                $scope.$broadcast(broadcast_config_1["default"].CLEAR);
                $scope.onToggleCompare();
                //Sends the selected portfolio to Portfolio menu in Navbar.
                //Navbar uses it to highlight the selected portfolio.
                setTimeout(function () {
                    $scope.$broadcast("manage:SelectedPortfolio", {
                        selectedPortfolio: treeID
                    });
                }, 0);
            }
        };
        $scope.initManage = function () {
            $scope.management = [
                {
                    Command: "DisplayCategoriesDefinition",
                    displayText: "Define Categories",
                    name: "Categories Definition"
                },
                {
                    Command: "DisplayCategoryAssignment",
                    displayText: "Assign Categories",
                    name: "Assign Categories"
                }
            ];
            $scope.menuLoaded = 2;
        };
        $scope.injectActionMenu = function (menuArray, management) {
            menuArray.unshift({
                Command: "DESCRIPTION",
                displayText: "Description",
                menuID: "Description",
                name: "Description",
                nodeID: $scope.selected._id
            });
            // Only add common data when shared data is there.
            for (var i = 0; i < management.length; i++) {
                if (management[i].displayText == "Shared Data") {
                    menuArray.push({
                        Command: "COMMON_DATA",
                        displayText: "Common Data",
                        menuID: "CommonSharedData",
                        name: "Common Data",
                        nodeID: $scope.selected._id
                    });
                    break;
                }
            }
            $scope.menuLoaded = 2;
        };
        $scope.checkAccess = function (access, role) {
            return access['portfolioAdmin'] && role === 'a' ||
                access['contributor'] && role === 'c' ||
                access['observer'] && role === 'o';
        };
        var doNotDisplayPlatformSchemaForLeafNode = function (templates) {
            return ($scope.selected['children'].length > 0 ||
                ($scope.selected['children'].length == 0 &&
                    templates[$scope.selected['templates'][0]] &&
                    templates[$scope.selected['templates'][0]]['leaf']));
        };
        var getListOfTemplatesInSelectedNodeAndUnder = function (currentNode, templates) {
            if (templates.indexOf(currentNode['templates'][0]) == -1) {
                templates.push(currentNode['templates'][0]);
            }
            if (currentNode['children'].length > 0) {
                for (var i = 0; i < currentNode['children'].length; i++) {
                    templates = getListOfTemplatesInSelectedNodeAndUnder(currentNode['children'][i], templates);
                }
            }
            return templates;
        };
        var doNotDisplaySchemaWithDifferentTemplate = function (templates) {
            // Changed to display all no matter what template it is.
            return true;
            // let templateUsedInSchema = Object.keys(templates)[0];
            // let listOfTemplatesInSelectedNodeAndUnder =
            //     getListOfTemplatesInSelectedNodeAndUnder($scope.selected, []);
            // return listOfTemplatesInSelectedNodeAndUnder.indexOf(templateUsedInSchema) != -1;
        };
        $scope.addUniversalIO = function (menuArray) {
            var universalIOs = [];
            var rootnode = $scope.treeObj.treeData;
            if (rootnode.univSchema) {
                var schemaNames = Object.keys(rootnode.univSchema).sort();
                var role = rootnode.role;
                for (var i = 0; i < schemaNames.length; i++) {
                    if ($scope.checkAccess(rootnode.univSchema[schemaNames[i]]['access'], role) && doNotDisplayPlatformSchemaForLeafNode(rootnode.univSchema[schemaNames[i]]['templates']) && doNotDisplaySchemaWithDifferentTemplate(rootnode.univSchema[schemaNames[i]]['templates'])) {
                        universalIOs.push({
                            Command: "UNIVERSAL_OUTPUT",
                            displayText: schemaNames[i].toString(),
                            menuID: "UniversalIO:" + schemaNames[i],
                            name: "UniversalIO:" + schemaNames[i],
                            nodeID: $scope.selected._id
                        });
                    }
                }
                if (universalIOs.length) {
                    menuArray.push({
                        Command: "UNIVERSAL_IO",
                        displayText: "Universal Table",
                        menuID: "UniversalIO",
                        name: "UniversalIO",
                        nodeID: $scope.selected._id,
                        dropdown: universalIOs
                    });
                }
            }
        };
        var sendDefaultReportOptionsAndTreeFilters = function (defaultReportOptions, defaultTreeViewFilters) {
            $scope.$broadcast(broadcast_config_1["default"].SET_DEFAULT_AND_TREE_FILTER, {
                defaultReportOptions: defaultReportOptions,
                defaultTreeViewFilters: defaultTreeViewFilters
            });
        };
        var sendSelectedNodeDetails = function (selectedNode) {
            $scope.$broadcast("Tree:NodeSelected", {
                selected: selectedNode
            });
        };
        var reinstateTree = function () {
            if ($scope.originalTreeID == $scope.treeObj.treeName) {
                $scope.expandedNodeIDs.forEach(function (nodeID) {
                    $scope.treeObj.nodeMap[nodeID]['expanded'] = true;
                });
            }
        };
        var getExpandedNodeIDs = function (nodeMap) {
            var nodeIDs = Object.keys(nodeMap);
            return nodeIDs.filter(function (nodeID) {
                return nodeMap[nodeID]['expanded'];
            });
        };
        /**
         * Load tree.
         *
         * @param treeID {string} Tree id, iki portfolio name.
         * @param params {{}} Query string object. Including tree
         *     id (portfolio), selected tree node id (treenode),
         *     and selected menu id (menu). Undefined means this
         *     is from selecting portfolio.
         */
        $scope.initTree = function (treeID, params) {
            $scope.command = "EMPTY_PAGE";
            $scope.searching = false;
            $scope.menus = [];
            $scope.action = [];
            // Load tree by portfolio.
            if (params && params["portfolio"]) {
                treeID = params["portfolio"];
            }
            var selectedNodeId;
            if (params && params["treenode"]) {
                selectedNodeId = params["treenode"];
            }
            var isTagsDataLoaded = $scope.treeObj && $scope.excludeTags && $scope.tagsLoaded ? true : false;
            var isTreeBackgroundLoaded = $scope.treeObj && $scope.filtersOnBackend && $scope.treeBackgroundLoaded ? true : false;
            // If tree id exists, either from selecting portfolio,
            // or from query string, load tree.
            if (treeID) {
                $scope.treeLoaded = 1;
                $scope.treeIDGot = treeID;
                $scope.selected = undefined;
                sendSelectedNodeDetails($scope.selected);
                $scope.defaultReportOptions = null;
                $scope.timeStamp = Date.now();
                $scope.expandedNodeIDs = $scope.treeObj && $scope.treeObj.nodeMap ?
                    getExpandedNodeIDs($scope.treeObj.nodeMap) : [];
                var previousTreeId = $scope.treeObj && $scope.treeObj.treeName ? $scope.treeObj.treeName : '';
                $scope.originalTreeID = previousTreeId;
                //checks if category tags are loaded, excludeTags key is true and portfolio is the same, implies filering based operations
                if ((isTagsDataLoaded || isTreeBackgroundLoaded) && treeID == previousTreeId) {
                    var savedTreeFilters = shareLink.getTreeFilters();
                    var appliedTreeFilter = null;
                    if (typeof savedTreeFilters !== 'undefined' && savedTreeFilters !== null) {
                        appliedTreeFilter = savedTreeFilters;
                    }
                    $scope.treeObj.filterTreeSubnodes(appliedTreeFilter);
                    var savedTreeExcludeFilters = shareLink.getTreeExcludeFilters();
                    var appliedTreeExcludeFilter = null;
                    if (savedTreeExcludeFilters && typeof savedTreeExcludeFilters !== 'undefined' && savedTreeExcludeFilters.length > 0) {
                        appliedTreeExcludeFilter = savedTreeExcludeFilters;
                        $scope.treeObj.excludeNodeBySubnodes(appliedTreeExcludeFilter);
                    }
                    $scope.treeObj.updateLeafParents();
                    reinstateTree();
                    $scope.treeLoaded = 2;
                    $scope.onSelectNodeWithParam(undefined, params);
                }
                else {
                    var loadQueueIdentifier = $scope.timeStamp;
                    smartorgApi.firstNLevelTreeFor(treeID, 4, selectedNodeId).then(function (response) {
                        var nodeList = response.nodeList, defaultReportOptions = response.defaultReportOptions, defaultTreeViewFilters = response.defaultTreeViewFilters, defaultTreeColors = response.defaultTreeColors;
                        if (nodeList) {
                            if ($scope.currentTreeColors != undefined) {
                                $scope.showTreeColors = angular.copy($scope.currentTreeColors);
                            }
                            else {
                                $scope.showTreeColors = defaultTreeColors;
                            }
                            $scope.$broadcast('tree:showTreeColors', {
                                showTreeColors: $scope.showTreeColors
                            });
                            $scope.reportOptionString = btoa(JSON.stringify(defaultReportOptions));
                            sendDefaultReportOptionsAndTreeFilters(defaultReportOptions, defaultTreeViewFilters);
                            if (nodeList.status) {
                                $scope.treeLoaded = 2;
                                // console.log(nodeList);
                            }
                            else {
                                $scope.defaultReportOptions = defaultReportOptions;
                                var treeMaker = new tree_maker_1["default"].TreeMaker(nodeList, treeID, $scope.showTreeColors);
                                $scope.treeObj = new tree_logic_1["default"].JsonTree(treeMaker.jsonTree, 2);
                                $scope.treeObj.categoriesConfig = treeMaker.categoriesConfig;
                                $scope.treeObj.dropdownCategoryConfig = treeMaker.dropdownCategoryConfig;
                                var treeviewFilter = defaultTreeViewFilters ? defaultTreeViewFilters.filterLogic : null;
                                $scope.treeObj.setDefaultTreeViewFilters(treeviewFilter);
                                shareLink.setDefaultTreeFilters(treeviewFilter);
                                if ($scope.filtersOnBackend) {
                                    shareLink.setTreeFilters(treeviewFilter);
                                }
                                reinstateTree();
                                var savedTreeFilters = shareLink.getTreeFilters();
                                var appliedTreeFilter_1 = treeviewFilter;
                                if (typeof savedTreeFilters !== 'undefined' && savedTreeFilters !== null) {
                                    appliedTreeFilter_1 = savedTreeFilters;
                                }
                                $scope.treeObj.filterTreeSubnodes(appliedTreeFilter_1);
                                var treeviewExcludeFilter = 'excludedTags' in defaultTreeViewFilters ? defaultTreeViewFilters.excludedTags : [];
                                $scope.treeObj.setDefaultTreeViewExcludeFilters(treeviewExcludeFilter);
                                shareLink.setDefaultTreeExcludeFilters(treeviewExcludeFilter);
                                if ($scope.filtersOnBackend) {
                                    shareLink.setTreeExcludeFilters(treeviewExcludeFilter);
                                }
                                var savedTreeExcludeFilters = shareLink.getTreeExcludeFilters();
                                var appliedTreeExcludeFilter_1 = treeviewExcludeFilter;
                                if (savedTreeExcludeFilters && typeof savedTreeExcludeFilters !== 'undefined' && savedTreeExcludeFilters.length > 0) {
                                    appliedTreeExcludeFilter_1 = savedTreeExcludeFilters;
                                    $scope.treeObj.excludeNodeBySubnodes(appliedTreeExcludeFilter_1);
                                }
                                else if (appliedTreeExcludeFilter_1 && typeof appliedTreeExcludeFilter_1 !== 'undefined' && appliedTreeExcludeFilter_1.length > 0) {
                                    $scope.treeObj.excludeNodeBySubnodes(appliedTreeExcludeFilter_1);
                                }
                                // $scope.treeLoaded = 2;
                                $scope.$apply();
                                // Load Menu when needed
                                $scope.onSelectNodeWithParam(undefined, params);
                                $scope.appliedTreeFilter = appliedTreeFilter_1;
                                $scope.appliedTreeExcludeFilter = appliedTreeExcludeFilter_1;
                                $timeout(function () {
                                    backgroundLoading(treeID, appliedTreeFilter_1, appliedTreeExcludeFilter_1);
                                    // backgroundCatAndTagsLoading(treeID, appliedTreeFilter, appliedTreeExcludeFilter);
                                });
                                $timeout(function () {
                                    $('.lastUpdatedTooltip').popover({
                                        placement: 'right',
                                        trigger: 'hover'
                                    }).on('mouseleave', function () {
                                        var _this = this;
                                        if (!$('.popover:hover').length) {
                                            $(_this).popover('hide');
                                            $scope.$apply();
                                        }
                                    });
                                }, 500);
                            }
                        }
                        else {
                            $scope.treeLoaded = 2;
                            $scope.showAlert("danger", "Error: ", response.message);
                        }
                    })["catch"](function (err) {
                        $scope.treeLoaded = 2;
                        if (params && params["portfolio"]) {
                            $scope.showAlert("info", "Not Available", "The portfolio in your local history is no longer available.");
                        }
                        else {
                            $scope.showAlert("danger", "Server Error " + err.status, err.message);
                        }
                    });
                }
            }
        };
        $scope.$on("search:ChangeTimeStamp", function (event, args) {
            $scope.timeStamp = args;
        });
        function backgroundLoading(treeID, appliedTreeFilter, appliedTreeExcludeFilter) {
            smartorgApi.treeFor(treeID).then(function (rs) {
                if (rs.status) {
                    $scope.treeLoaded = 2;
                }
                else {
                    var treeMaker = new tree_maker_1["default"].TreeMaker(rs, treeID, $scope.showTreeColors);
                    $scope.treeObj.fullTree = new tree_logic_1["default"].JsonTree(treeMaker.jsonTree, 2);
                    Object.entries($scope.treeObj.fullTree.nodeMap).forEach(function (_a) {
                        var id = _a[0], node = _a[1];
                        var n = $scope.treeObj.nodeMap[id];
                        if (n && (!n.children || n.children.length === 0)) {
                            $scope.treeObj.nodeMap[id].children = node.children;
                        }
                    });
                    $scope.treeObj.buildNodeMap($scope.treeObj.treeData);
                    $scope.treeObj.filterTreeSubnodes(appliedTreeFilter);
                    if (appliedTreeExcludeFilter.length > 0) {
                        $scope.treeObj.excludeNodeBySubnodes(appliedTreeExcludeFilter);
                    }
                    $scope.treeObj.updateLeafParents();
                    reinstateTree();
                    $scope.treeLoaded = 2;
                    var getTagsSeparately = $scope.excludeTags &&
                        (!appliedTreeFilter || appliedTreeFilter === "") &&
                        (!appliedTreeExcludeFilter || appliedTreeExcludeFilter.length === 0);
                    var loadInBackground = !getTagsSeparately && $scope.filtersOnBackend;
                    //if excludeTags is true, and there was no default filter found applied
                    if (getTagsSeparately) {
                        $scope.treeLoaded = 5;
                        backgroundCatAndTagsLoading(treeID, treeMaker, appliedTreeFilter, appliedTreeExcludeFilter);
                    }
                    else if (loadInBackground) {
                        $scope.treeLoaded = 5;
                        backgroundTreeLoading(treeID, appliedTreeFilter, appliedTreeExcludeFilter);
                    }
                    $timeout();
                }
            });
        }
        function backgroundTreeLoading(treeID, appliedTreeFilter, appliedTreeExcludeFilter) {
            var previousDefFilters = $scope.treeObj.defaultTreeViewFilters ? $scope.treeObj.defaultTreeViewFilters : "";
            var previousDefExcluFilters = $scope.treeObj.defaultTreeViewExcludeFilters ? $scope.treeObj.defaultTreeViewExcludeFilters : "";
            smartorgApi.treeInBackground(treeID).then(function (rs) {
                if (rs.status) {
                    $scope.treeLoaded = 2;
                }
                else {
                    var treeMaker = new tree_maker_1["default"].TreeMaker(rs, treeID, $scope.showTreeColors);
                    $scope.treeObj = new tree_logic_1["default"].JsonTree(treeMaker.jsonTree, 2);
                    $scope.treeObj.categoriesConfig = treeMaker.categoriesConfig;
                    $scope.treeObj.dropdownCategoryConfig = treeMaker.dropdownCategoryConfig;
                    $scope.treeObj.fullTree = __assign({}, $scope.treeObj);
                    $scope.treeObj.filterTreeSubnodes(appliedTreeFilter);
                    if (appliedTreeExcludeFilter.length > 0) {
                        $scope.treeObj.excludeNodeBySubnodes(appliedTreeExcludeFilter);
                    }
                    $scope.treeObj.updateLeafParents();
                    $scope.treeObj.setDefaultTreeViewFilters(previousDefFilters);
                    $scope.treeObj.setDefaultTreeViewExcludeFilters(previousDefExcluFilters);
                    $scope.treeBackgroundLoaded = true;
                    reinstateTree();
                    $scope.treeLoaded = 2;
                    $timeout();
                }
            });
        }
        function backgroundCatAndTagsLoading(treeID, treeMaker, appliedTreeFilter, appliedTreeExcludeFilter) {
            smartorgApi.CatAndTagsForTree(treeID).then(function (rs) {
                if (rs.status) {
                    $scope.treeLoaded = 2;
                }
                else {
                    var tagsNodeMap_1 = treeMaker.getTagsNodeMap(rs);
                    var updatedNodeMap_1 = {};
                    Object.entries($scope.treeObj.nodeMap).forEach(function (_a) {
                        var id = _a[0], node = _a[1];
                        updatedNodeMap_1[id] = treeMaker.appendTagsUsingMap(node, tagsNodeMap_1);
                    });
                    $scope.treeObj.nodeMap = updatedNodeMap_1;
                    $scope.treeLoaded = 2;
                    $scope.tagsLoaded = true;
                    $scope.$apply();
                }
            });
        }
        $scope.getSubtree = function (nodeId) {
            $scope.treeObj.nodeMap[nodeId].loading = true;
            smartorgApi.getSubtree([{ _id: nodeId }]).then(function (rs) {
                if (rs.status) {
                    $scope.treeLoaded = 2;
                    $scope.treeObj.fullTree.nodeMap[nodeId].loading = false;
                }
                else {
                    var treeMaker = new tree_maker_1["default"].TreeMaker(rs, $scope.treeID, $scope.showTreeColors); //.nodemap has treeNodes array with childrenIds, not children itself for now
                    var gotNode = $scope.treeObj.fullTree.nodeMap[nodeId] ? $scope.treeObj.fullTree.nodeMap[nodeId] : $scope.treeObj.nodeMap[nodeId];
                    var parentGot = gotNode.parent ? gotNode.parent : null; //backup of parent
                    treeMaker.assignChildren(gotNode);
                    gotNode.parent = parentGot; //reassignemnet of parent
                    treeMaker.assignParent(gotNode);
                    //optimise it
                    Object.entries($scope.treeObj.fullTree.nodeMap).forEach(function (_a) {
                        var id = _a[0], node = _a[1];
                        var n = $scope.treeObj.nodeMap[id];
                        if (n && (!n.children || n.children.length === 0)) {
                            $scope.treeObj.nodeMap[id].children = node.children;
                        }
                    });
                    $scope.treeObj.buildNodeMap($scope.treeObj.treeData);
                    var savedTreeFilters = shareLink.getTreeFilters();
                    var appliedTreeFilter = null;
                    if (typeof savedTreeFilters !== 'undefined' && savedTreeFilters !== null) {
                        appliedTreeFilter = savedTreeFilters;
                        $scope.treeObj.filterTreeSubnodes(appliedTreeFilter);
                    }
                    var savedTreeExcludeFilters = shareLink.getTreeExcludeFilters();
                    var appliedTreeExcludeFilter = null;
                    if (savedTreeExcludeFilters && typeof savedTreeExcludeFilters !== 'undefined' && savedTreeExcludeFilters.length > 0) {
                        appliedTreeExcludeFilter = savedTreeExcludeFilters;
                        $scope.treeObj.excludeNodeBySubnodes(appliedTreeExcludeFilter);
                    }
                    $scope.treeObj.updateLeafParents();
                    reinstateTree();
                    $scope.treeLoaded = 2;
                    $scope.treeObj.nodeMap[nodeId].loading = false;
                    $scope.treeObj.nodeMap[nodeId].expanded = true;
                    $timeout();
                }
            });
        };
        /**
         * On selecting a tree node, shows the right panel menu.
         *
         * @param {string} nodeID Selected tree node id.
         */
        $scope.onSelectNode = function (nodeID) {
            $scope.onSelectNodeWithParam(nodeID, undefined);
        };
        $scope.onSelectNodeWithParam = function (nodeID, params) { return __awaiter(_this_1, void 0, void 0, function () {
            var loadFromHistory, oldNodeID, treeNode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loadFromHistory = false;
                        oldNodeID = nodeID;
                        if (!nodeID && params && params["treenode"]) {
                            nodeID = decodeURIComponent(params["treenode"]);
                            loadFromHistory = true;
                        }
                        treeNode = $scope.treeObj.nodeMap[nodeID];
                        // Here the digest is not finished yet, so selected
                        // is still the last node.
                        if ($scope.prevSelected && treeNode) {
                            if ($scope.prevSelected.isLeaf() ^ treeNode.isLeaf()) {
                                $scope.reportOptionString = EMPTY_REPORT_OPTIONS;
                                $scope.$broadcast(broadcast_config_1["default"].RESET);
                            }
                        }
                        /**
                         * Keep the previous node.
                         */
                        $scope.prevSelected = treeNode;
                        if (nodeID && $scope.isInav) {
                            smartorgApi.getNColCanvasConfig(nodeID).then(function (nColCanvasConfig) {
                                localStorage.setItem('nColCanvasConfig', angular.toJson(nColCanvasConfig));
                            })["catch"](function (err) {
                                $scope.showAlert("danger", "Server Error " + err.status, "Failed to fetch N-Column Canvas Config.");
                            });
                        }
                        // Load from cookie/share but not found
                        if (loadFromHistory && !treeNode) {
                            $scope.showAlert("info", "Not Available", "The selected tree node in your local history is no longer available.");
                            return [2 /*return*/];
                        }
                        if (nodeID) {
                            $scope.workbenchLoading.start();
                            $scope.expandPanel('right');
                        }
                        return [4 /*yield*/, $scope.initReportOptions(nodeID, params)];
                    case 1:
                        _a.sent();
                        $scope.initMenu(nodeID, params);
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Load menu base selected on tree node.
         *
         * @param treeNodeId {string} selected tree node id.
         * @param params {{}} Query string info. Undefined means
         *     this is coming from user selecting tree node.
         */
        $scope.initMenu = function (treeNodeId, params) {
            // Load menu by tree node id.
            if (params && params["treenode"]) {
                treeNodeId = decodeURIComponent(params["treenode"]);
            }
            // tree node exists
            $scope.selected = treeNodeId ? $scope.treeObj.nodeMap[treeNodeId] : null;
            sendSelectedNodeDetails($scope.selected);
            if ($scope.selected && $scope.selected.isVisible()) {
                $scope.treeObj.expandBranch(treeNodeId);
                $scope.menuLoaded = 1;
                if ($scope.treeObj.categoriesConfig) {
                    var showCateAssignPage = (($scope.treeObj.categoriesConfig.filter(function (_a) {
                        var ShowOnCategory = _a.ShowOnCategory;
                        return (ShowOnCategory === true || ShowOnCategory === 'true');
                    })).length > 0);
                }
                // load menu from api
                smartorgApi.actionMenuFor(treeNodeId).then(function (menu) {
                    $scope.action = showCateAssignPage ? menu["menuItems"]["Actions"] :
                        menu["menuItems"]["Actions"].filter(function (_a) {
                            var Command = _a.Command;
                            return (Command !== "ProjectCategoryAssignment");
                        });
                    if ($scope.selected) {
                        $scope.injectActionMenu($scope.action, menu["menuItems"]["Management"]);
                        $scope.addUniversalIO($scope.action);
                        $scope.menuLoaded = 2;
                        $scope.$apply();
                        // Show menu if needed
                        $scope.selectMenuItem(undefined, params);
                    }
                })["catch"](function (err) {
                    $scope.menuLoaded = 2;
                    $scope.workbenchLoading.end();
                    $scope.showAlert("danger", "Server Error " + err.status, "Failed to load menu information.");
                });
            }
            else {
                $scope.workbenchLoading.end();
                $scope.action = [];
                $scope.selected = null;
                sendSelectedNodeDetails($scope.selected);
                $scope.selectedMenuItem = undefined;
                $scope.command = "EMPTY_PAGE";
            }
        };
        $scope.findMenuItem = function (menuName, menu) {
            var actionList = menu;
            var menuItem;
            for (var i = 0; i < actionList.length && !menuItem; i++) {
                if (actionList[i].menuID === menuName) {
                    menuItem = actionList[i];
                }
                else if (actionList[i].dropdown) {
                    for (var j = 0; j < actionList[i].dropdown.length; j++) {
                        if (actionList[i].dropdown[j].menuID === menuName) {
                            menuItem = actionList[i].dropdown[j];
                            // Expand cluster if sub menu is selected.
                            $scope.showClusterMenu = {
                                name: actionList[i].name
                            };
                            break;
                        }
                    }
                }
            }
            return menuItem;
        };
        /**
         * Handle user selecting action item.
         *
         * @param menuName
         * @param params
         */
        $scope.selectMenuItem = function (menuName, params) {
            // Override value by priority
            if ($scope.selectedMenuItem) {
                menuName = $scope.selectedMenuItem.menuID;
            }
            if (params && params["menu"]) {
                menuName = params["menu"];
            }
            // Clean up to prevent unexpected action
            // if there is a previous value.
            $scope.showClusterMenu = {
                name: undefined
            };
            var menuItem;
            if (menuName) {
                menuItem = $scope.findMenuItem(menuName, $scope.action);
            }
            if (menuItem) {
                $scope.selectedMenuItem = menuItem;
                // ng-switch prevent directive from initializing.
                // Apply a ng-switch option so the directive is
                // enabled, so duplicated broadcasting is no longer
                // needed.
                // $scope.command = menuItem.Command;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
                shareLink.setValue('menu', menuName);
                $scope.onSelectAction(menuItem.nodeID, menuItem.menuID, menuItem.Command);
            }
            else {
                if ($scope.selected) {
                    $scope.showDescription();
                }
                else {
                    $scope.command = "EMPTY_PAGE";
                    $scope.workbenchLoading.end();
                }
                shareLink.clearValue('menu');
                shareLink.clearValue('options');
            }
            setTimeout(function () {
                $scope.$apply();
            });
        };
        $scope.checkSpecialRules = function (command) {
            var reportOptionObject = JSON.parse(atob($scope.reportOptionString));
            //
            // if (command === 'INNOVATION_SCREEN') {
            //     if ("groupKey" in reportOptionObject &&
            //         "groupByList" in reportOptionObject) {
            //         $scope.showAlert("warning",
            //             "Action Not Applicable",
            //             "Group by is not supported for Innovation Screen. " +
            //             "Probabilities of projects cannot be combined.");
            //
            //         return false;
            //     }
            // }
            if (command === 'BUBBLE_CHART') {
                if ("groupKey" in reportOptionObject) {
                    $scope.showAlert("warning", "Action Not Applicable", 'Group By not applicable to Bubble Chart');
                    return false;
                }
            }
            return true;
        };
        // ====================================================================
        // solution source:https://github.com/ReactiveX/RxJava/issues/3870
        //original problem is in Add Table, when select both colorby and groupby
        //subnodes, it will show error, then the reactive observable will
        // get stuck.
        $scope
            .$createObservableFunction("onSelectAction")
            .switchMap(function (e) { return rx.Observable.onErrorResumeNext(performAction(e)["catch"](function (err) {
            handleActionError(err);
        }), rx.Observable.empty()); })
            .subscribe(handleActionResponse, handleActionError);
        // =======================================================================================
        function showFeatureComingSoon() {
            $scope.showAlert('info', 'Feature Coming Soon!', 'We are working on implementing "Group by" and "Color by" together.');
            $scope.command = 'NOT_SUPPORT';
            $scope.workbenchLoading.end();
        }
        function generateReportOptionsForSubmit(reportOptionString) {
            if (reportOptionString === void 0) { reportOptionString = EMPTY_REPORT_OPTIONS; }
            var reportOptions = JSON.parse(atob(reportOptionString));
            var fixedFilterLogic = $scope.treeObj.currentFilterLogic;
            if (fixedFilterLogic) {
                if (reportOptions.filterLogic) {
                    reportOptions.filterLogic = "(" + reportOptions.filterLogic + ") and (" + fixedFilterLogic + ")";
                }
                else {
                    reportOptions.filterLogic = fixedFilterLogic;
                }
            }
            return btoa(JSON.stringify(reportOptions));
        }
        /**
         * When selecting a MENU item, show information in center main
         * area. Each menu item has its id and command.
         *
         * @param {string} nodeID This menu item is responsable to a
         *     tree node. This is the tree node id.
         * @param {string} actionID Selected menu id.
         * @param {string} command Menu command.
         */
        function performAction(args) {
            $scope.currentAction = args;
            if (args.length == 0) {
                return rx.Observable.empty();
            }
            var nodeID = args[0], actionID = args[1], command = args[2];
            if ($rootScope.smartorgDirty) {
                var discardChange = confirm("The unsaved data will be lost. Do you want to proceed?");
                if (discardChange) {
                    $rootScope.smartorgDirty = false;
                }
                else {
                    return;
                }
            }
            // $scope.command = command;
            var specialActionCommands = [
                'DESCRIPTION',
                'COMMON_DATA',
                'UNIVERSAL_OUTPUT',
                'UNIVERSAL_OUTPUT_NEW',
                'DOWNLOAD_SPREADSHEET',
                'ProjectCategoryAssignment',
                'GUIDANCE',
                'EXPERIMENT_MANAGEMENT',
                'CRAFT_EXPERIMENT',
                'NEW_LEARNING_PLAN',
                'ISSUE_VIEW',
                'EXPERIMENT_VIEW',
                'EXPERIMENT_PRIORITY',
                'ISSUE_SCANNING',
                'LP_MILESTONES',
                'LP_EXPERIMENTS',
                'LP_RESULTS',
                'LP_PLAN_SUMMARY',
                'DASHBOARD',
                'READINESS',
                'DASHBOARD_EXPERIMENT_PRIORITY',
                'D_PDF_VIEWER',
                'N_COLUMN_CANVAS',
                'DFV',
                'GPE',
                'SWOT',
                'IGNORANCE_BOARD',
                'IMPACT'
            ];
            // Every command with the same broadcast key will catch
            // the broadcasting. Maybe use command as key is a
            // better idea?
            //
            // Use unique key improve the responding speed a lot.
            //
            // Currently which command is triggered is controlled
            if (command != 'DOWNLOAD_SPREADSHEET') {
                $scope.workbenchLoading.start();
            }
            if (actionID &&
                nodeID &&
                specialActionCommands.indexOf(command) < 0) {
                $scope.menuID = actionID;
                $scope.$broadcast(broadcast_config_1["default"].APPLY, {
                    options: JSON.parse(atob($scope.reportOptionString)),
                    command: command
                });
                var reportOptions = generateReportOptionsForSubmit($scope.reportOptionString);
                var excludeFilters = btoa(JSON.stringify($scope.treeObj.currentExcludedFilterTags));
                if (!$scope.checkSpecialRules(command)) {
                    $scope.$broadcast("workspace:action", {
                        command: command,
                        config: {
                            "data": {},
                            "actionMenuItem": $scope.selectedMenuItem.displayText,
                            "nodeID": $scope.selected._id
                        }
                    });
                    $scope.workbenchLoading.end();
                    return rx.Observable.empty();
                }
                //console.log(actionID);
                //console.log(nodeID);
                //console.log(reportOptions);
                $scope.currentPerformActionCommand = command;
                if (some_logic_1.checkCommandGroupByPlusColorBy(command, reportOptions)) {
                    if (command === 'GOAL_ANALYSIS' && localStorage.getItem('GoalAnalysisInfo')
                        && nodeID in JSON.parse(localStorage.getItem('GoalAnalysisInfo'))) {
                        var rangeInfo = JSON.parse(localStorage.getItem('GoalAnalysisInfo'))[nodeID];
                        return rx.Observable.fromPromise(smartorgApi.performGoalAnalysis(nodeID, btoa(JSON.stringify(rangeInfo)), reportOptions, btoa(JSON.stringify($scope.treeObj.currentExcludedFilterTags)), actionID, null));
                    }
                    return rx.Observable.fromPromise(smartorgApi.actionFor(actionID, nodeID, reportOptions, excludeFilters));
                }
                else {
                    showFeatureComingSoon();
                    return rx.Observable.empty();
                }
            }
            else if (command == "DisplayCategoriesDefinition") {
                // Load category config.
                $scope.loadCategory();
            }
            else if (command == "DisplayCategoryAssignment") {
                // return rx.Observable.create(function (observer) {
                //     const ok = showAssignCategory(command);
                //     observer.next(ok);
                // });
                $scope.showAssignCategory(command);
            }
            else if (command == "DESCRIPTION") {
                $scope.showDescription();
            }
            else if (command == "GUIDANCE") {
                $scope.showGuidance();
            }
            else if (command == "UNIVERSAL_OUTPUT" ||
                command == "UNIVERSAL_OUTPUT_NEW") {
                $scope.showUniversalOutput(command);
            }
            else if (command == "DOWNLOAD_SPREADSHEET") {
                $scope.downloadSpreadsheet();
            }
            else if (command == "COMMON_DATA") {
                setTimeout(function () {
                    $scope.command = "WORK_SPACE";
                    setTimeout(function () {
                        $scope.$apply();
                        $scope.$broadcast("workspace:action", {
                            command: 'COMMON_DATA',
                            config: {
                                nodeId: nodeID,
                                actionMenuItem: $scope.selectedMenuItem.displayText
                            }
                        });
                        $timeout(function () {
                            $scope.workbenchLoading.end();
                        }, 300);
                    }, 0);
                }, 0);
            }
            else if (command == "ProjectCategoryAssignment") {
                $scope.command = "WORK_SPACE";
                var reportOptions = JSON.parse(atob($scope.reportOptionString || EMPTY_REPORT_OPTIONS));
                var siblingNodeTags_1 = reportOptions.compareToNodeID ?
                    $scope.treeObj.nodeMap[reportOptions.compareToNodeID].tags : undefined;
                setTimeout(function () {
                    $scope.$broadcast("workspace:action", {
                        command: 'ProjectCategoryAssignment',
                        config: {
                            nodeId: nodeID,
                            node: $scope.selected,
                            siblingNodeTags: siblingNodeTags_1,
                            actionMenuItem: $scope.selectedMenuItem.displayText,
                            categoriesConfig: $scope.treeObj.categoriesConfig,
                            // treeNodeMap: $scope.treeObj.nodeMap,
                            treeViewFilter: $scope.treeObj.currentFilterLogic
                        }
                    });
                    $timeout(function () {
                        $scope.workbenchLoading.end();
                    }, 300);
                }, 0);
            }
            else if (command == 'ISSUE_SCANNING' || command == 'DASHBOARD' ||
                command == 'READINESS' || command == 'PDF_VIEWER' ||
                command == 'D_PDF_VIEWER' || command == 'DFV' || command == 'IMPACT' ||
                command == 'IGNORANCE_BOARD' || command == 'DISCOVERY_GRID' ||
                command == 'GPE') {
                $scope.command = "WORK_SPACE";
                setTimeout(function () {
                    $scope.$apply();
                    $scope.selectedMenuItem = $scope.findMenuItem(command, $scope.action);
                    setTimeout(function () {
                        $scope.$broadcast("workspace:action", {
                            command: command,
                            config: {
                                'node': $scope.selected,
                                'actionMenuItem': $scope.selectedMenuItem.displayText,
                                'userName': $scope.userName
                            }
                        });
                        $scope.$apply();
                    }, 0);
                });
            }
            else if (command == 'EXPERIMENT_PRIORITY' || command == 'LP_MILESTONES' ||
                command == 'LP_EXPERIMENTS' || command == 'LP_RESULTS' || command == 'LP_PLAN_SUMMARY' ||
                command == 'DASHBOARD_EXPERIMENT_PRIORITY') {
                $scope.command = "WORK_SPACE";
                setTimeout(function () {
                    $scope.$apply();
                    $scope.selectedMenuItem = $scope.findMenuItem(command, $scope.action);
                    setTimeout(function () {
                        $scope.astro.getInavIssueAndExperiment($scope.selected._id)
                            .then(function (res) {
                            $scope.$broadcast("workspace:action", {
                                command: command,
                                config: {
                                    'node': $scope.selected, 'issueData': res,
                                    'actionMenuItem': $scope.selectedMenuItem.displayText
                                }
                            });
                            $scope.$apply();
                        })["catch"](function (err) {
                            $scope.showAlert("danger", "Server Error " + err.status, err.message);
                        });
                    }, 0);
                });
            }
            else if ((command == 'CRAFT_EXPERIMENT') || (command == 'ISSUE_VIEW') || (command == 'EXPERIMENT_VIEW') || (command == 'NEW_LEARNING_PLAN')
                || (command == 'SWOT') || (command == 'N_COLUMN_CANVAS')) {
                $scope.command = "WORK_SPACE";
                setTimeout(function () {
                    $scope.$apply();
                    $scope.selectedMenuItem = $scope.findMenuItem(command, $scope.action);
                    setTimeout(function () {
                        $scope.astro.getDataForInavExpMgmt($scope.selected._id)
                            .then(function (res) {
                            $scope.$broadcast("workspace:action", {
                                command: command,
                                config: {
                                    'node': $scope.selected,
                                    'actionMenuItem': $scope.selectedMenuItem.displayText,
                                    'userName': $scope.userName,
                                    'factors': res['factors'],
                                    'fte': res['fte'],
                                    'sectionNames': res['sectionNames'],
                                    'initLearningPlanSection': res['initLearningPlanSection']
                                }
                            });
                            $scope.$apply();
                        })["catch"](function (err) {
                            $scope.showAlert("danger", "Server Error " + err.status, err.message);
                        });
                    }, 0);
                });
            }
            return rx.Observable.empty();
        }
        function handleActionResponse(data) {
            $scope.command = "WORK_SPACE";
            $scope.$apply();
            var command = $scope.currentPerformActionCommand;
            console.log("Action response from", command);
            if (data['data']) {
                var reportOptions = JSON.parse(atob($scope.reportOptionString));
                var compareToNode = reportOptions.compareToNodeID ?
                    $scope.treeObj.nodeMap[reportOptions.compareToNodeID] : undefined;
                var config_1 = {
                    "config": data,
                    "actionMenuItem": $scope.selectedMenuItem.displayText,
                    "nodeID": $scope.selected._id,
                    "compareToNode": compareToNode,
                    "reportOptions": reportOptions,
                    "excludeFilters": btoa(JSON.stringify($scope.treeObj.currentExcludedFilterTags)),
                    "treeName": $scope.treeObj.treeName,
                    "nodeName": $scope.selected.name,
                    "node": $scope.selected
                };
                if (some_logic_1.nodeDetailsNotNeeded.indexOf(command) === -1) {
                    config_1['node'] = $scope.selected;
                }
                else {
                    config_1['nodeLastRecalc'] = $scope.selected.lastRecalc;
                }
                if (command == "BASIC_TABLE") {
                    config_1['menuID'] = $scope.menuID;
                    config_1['reportOptions'] = generateReportOptionsForSubmit($scope.reportOptionString);
                    config_1['excludeFilters'] = btoa(JSON.stringify($scope.treeObj.currentExcludedFilterTags));
                }
                $scope.$broadcast("workspace:action", {
                    command: command,
                    config: config_1
                });
            }
            else {
                $scope.command = "CUSTOM_ERROR_PAGE";
                $scope.errorMsg = "NOT_SUPPORT";
                if (data) {
                    $scope.showAlert("warning", "Not Supported: " + command, data['msg']);
                }
                else {
                    $scope.errorPageMsg = data;
                }
            }
            $timeout(function () {
                $scope.workbenchLoading.end();
            }, 300);
            // .catch((err: any) => {
            // )
        }
        function handleActionError(err) {
            $scope.workbenchLoading.end();
            $scope.command = "CUSTOM_ERROR_PAGE";
            if (err.status === 403) {
                $scope.showAlert("danger", err.statusText, "Session time out, redirecting to login page...");
                $timeout(function () {
                    $location.path('/login');
                }, 3000);
            }
            else {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            }
        }
        /**
         * Show description for currently selected node.
         */
        $scope.showDescription = function () {
            $scope.command = "WORK_SPACE";
            setTimeout(function () {
                $scope.$apply();
                $scope.selectedMenuItem = $scope.findMenuItem("Description", $scope.action);
                setTimeout(function () {
                    $scope.$broadcast("workspace:action", {
                        command: 'DESCRIPTION',
                        config: { 'node': $scope.selected }
                    });
                    $scope.$apply();
                }, 0);
            });
        };
        $scope.showGuidance = function () {
            $scope.command = "WORK_SPACE";
            setTimeout(function () {
                $scope.$apply();
                $scope.selectedMenuItem = $scope.findMenuItem("Guidance", $scope.action);
                setTimeout(function () {
                    $scope.$broadcast("workspace:action", {
                        command: 'GUIDANCE',
                        config: { 'node': $scope.selected }
                    });
                    $scope.$apply();
                }, 0);
            });
        };
        $scope.downloadSpreadsheet = function () {
            $scope.workbenchLoading.end();
            $scope.astro.downloadSpreadsheet($scope.selected._id).then(function (rs) {
                var modelData = rs.modelData;
                var extension = rs.extension;
                var templateName = rs.templateName;
                // var byteArray = new Uint8Array([atob(modelData)]);
                // const blob = new Blob([byteArray]);
                var byteArr = atob(modelData);
                var bytes = new Uint8Array(byteArr.length);
                for (var i = 0; i < byteArr.length; i++) {
                    bytes[i] = byteArr.charCodeAt(i);
                }
                var blob = new Blob([bytes], { type: 'application/vnd.ms-excel' });
                var filename = $scope.selected.name + "-" +
                    templateName + "-" + $scope.getDate() + "." + extension;
                saveAs(blob, filename);
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        $scope.getDate = function () {
            var dateInString = new Date().toString();
            var splitTimestamp = dateInString.split(" ");
            var timeWithoutSec = splitTimestamp[4].substring(0, splitTimestamp[4].length - 3);
            var timeZone = splitTimestamp.slice(6, splitTimestamp.length);
            return "" + splitTimestamp[1] + " " + splitTimestamp[2] + " " + splitTimestamp[3] + " " + timeWithoutSec + " " + timeZone;
        };
        /**
         * Show Universal Output for currently selected node.
         *
         * @param command {string} UNIVERSAL_OUTPUT to not show modal.
         */
        $scope.showUniversalOutput = function (command) {
            if (!some_logic_1.checkCommandGroupByPlusColorBy(command, $scope.reportOptionString)) {
                showFeatureComingSoon();
                return;
            }
            var reportOptions = JSON.parse(atob($scope.reportOptionString));
            var compareToNode = reportOptions.compareToNodeID ?
                $scope.treeObj.nodeMap[reportOptions.compareToNodeID] : undefined;
            var config = {
                'node': $scope.selected,
                'compareToNode': compareToNode,
                'schema': undefined,
                'reportOptionString': generateReportOptionsForSubmit($scope.reportOptionString),
                'excludeTreeFilters': $scope.treeObj.currentExcludedFilterTags,
                'isAdmin': $scope.isAdmin,
                'settings': undefined,
                'rootNode': $scope.treeObj.treeData
            };
            if ($scope.treeObj && $scope.selectedMenuItem &&
                command == 'UNIVERSAL_OUTPUT') {
                var schemaName = $scope.selectedMenuItem.displayText;
                var rootNode = $scope.treeObj.treeData;
                if (rootNode.univSchema && rootNode.univSchema[schemaName]) {
                    // Schema exists
                    config.schema = rootNode.univSchema[schemaName];
                }
            }
            $scope.command = "WORK_SPACE";
            var setPortfolioConfigAndBroadcast = function (portfolioConfig) {
                config.settings = portfolioConfig['table'];
                config.chartSettings = portfolioConfig['chart'];
                if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                    $scope.$apply();
                }
                if (command == 'UNIVERSAL_OUTPUT_NEW') {
                    $scope.selectedMenuItem = undefined;
                    config.createNew = true;
                }
                else {
                    config.createNew = false;
                }
                $scope.$broadcast("workspace:action", {
                    command: 'UNIVERSAL_OUTPUT',
                    config: config
                });
            };
            var portfolioName = $scope.treeObj.treeName;
            if (localStorage.getItem('PortfolioConfig') &&
                portfolioName in JSON.parse(localStorage.getItem('PortfolioConfig'))) {
                var portfolioConfig = JSON.parse(localStorage.getItem('PortfolioConfig'))[portfolioName];
                setPortfolioConfigAndBroadcast(portfolioConfig);
            }
            else {
                $scope.astro.getPortfolioConfig(portfolioName)
                    .then(function (portfolioConfig) {
                    setTimeout(function () {
                        setPortfolioConfigAndBroadcast(portfolioConfig);
                    });
                })["catch"](function (err) {
                    $scope.showAlert("danger", "Server Error " + err.status, err.message);
                });
            }
        };
        $scope.reloadRoot = function (menuId) {
            $scope.astro.nodeBy($scope.treeObj.treeData._id).then(function (returnValue) {
                $scope.treeObj.treeData.univSchema = returnValue.univSchema;
                if (menuId) {
                    shareLink.setValue('menu', menuId);
                }
                $scope.initMenu($scope.selected._id, {
                    menu: menuId
                });
            })["catch"](function (err) {
                console.error(err);
            });
        };
        // ============================================
        // Calculation Engine Log
        // ============================================
        /**
         * Show interface to fetch calculation engine logs
         */
        $scope.loadCalculationEngineLog = function (command) {
            $scope.workbenchLoading.end();
            setTimeout(function () {
                $scope.$apply();
                $scope.$broadcast("manage:" + command.trim());
            });
        };
        // ============================================
        // Pypeer Log
        // ============================================
        /**
         * Show interface to fetch pypeer logs
         */
        $scope.loadPypeerLog = function (command) {
            $scope.workbenchLoading.end();
            setTimeout(function () {
                $scope.$apply();
                $scope.$broadcast("manage:" + command.trim());
            });
        };
        // ============================================
        // Import Portfolio
        // ============================================
        /**
         * Show interface to import a portfolio
         */
        $scope.loadImportPortfolio = function (command) {
            $scope.workbenchLoading.end();
            setTimeout(function () {
                $scope.$apply();
                $scope.$broadcast("manage:" + command.trim());
            });
        };
        var loadNewTreeAndRefreshPortfolioMenu = function (newPortfolioName) {
            $scope.portfolioData.push({ text: newPortfolioName });
            $scope.portfolioData.sort(function (x, y) {
                var a = x.text.toLowerCase();
                var b = y.text.toLowerCase();
                return a === b ? 0 : a > b ? 1 : -1;
            });
            $scope.onSelectPortfolio(newPortfolioName);
        };
        /**
         *  Callback to import portfolio.
         */
        $scope.importPortfolioFromExport = function (includeData, pathToImportFiles64, newPortfolioName) {
            $scope.astro.importPortfolio(includeData, pathToImportFiles64, btoa(newPortfolioName))
                .then(function () {
                $scope.showAlert("success", "Success!", "'" + newPortfolioName + "' is imported successfully.");
                loadNewTreeAndRefreshPortfolioMenu(newPortfolioName);
            })["catch"](function () {
                $scope.showAlert("danger", "Failed!", newPortfolioName + " cannot be imported.");
            });
        };
        // ============================================
        // Create Portfolio
        // ============================================
        /**
         * Open modal window to create new portfolio.
         */
        $scope.loadCreatePortfolioModal = function (command) {
            $scope.workbenchLoading.end();
            setTimeout(function () {
                $scope.$apply();
                $scope.$broadcast("manage:" + command.trim());
            });
        };
        /**
         * Callback to save new portfolio.
         */
        $scope.createPortfolio = function (newPortfolioName) {
            $scope.astro.createPortfolio(newPortfolioName).then(function (res) {
                if (res && res['status'] == 409) {
                    $scope.showAlert("info", "Already exist!", "Portfolio '" + newPortfolioName + "' already exists.");
                }
                else if (res && res['status'] == 403) {
                    $scope.showAlert("danger", "Not allowed!", "A user without a group can't create a portfolio.");
                }
                else {
                    loadNewTreeAndRefreshPortfolioMenu(newPortfolioName);
                    $scope.showAlert("success", "Success!", "Portfolio is created successfully.");
                }
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        // ============================================
        // Configure Portfolio
        // ============================================
        /**
         * Open configuration page to configure portfolio
         */
        $scope.loadPortfolioConfiguration = function (command, saveGlobally, showInputConfig) {
            $scope.workbenchLoading.end();
            $scope.astro.getPortfolioConfig($scope.treeObj.treeName)
                .then(function (res) {
                setTimeout(function () {
                    $scope.$broadcast("manage:" + command.trim(), {
                        portfolioConfig: res,
                        saveGlobally: saveGlobally,
                        showInputConfig: showInputConfig
                    });
                });
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        // ============================================
        // Create Portfolio From Existing Portfolio
        // ============================================
        /**
         * Open modal window to create new portfolio.
         */
        $scope.loadCreatePortfolioFromExistingPortfolio = function (command) {
            $scope.workbenchLoading.end();
            setTimeout(function () {
                $scope.$broadcast("manage:" + command.trim(), {
                    categoriesConfig: $scope.treeObj.categoriesConfig,
                    acl: $scope.treeObj.treeData.acl,
                    univSchema: $scope.treeObj.treeData.univSchema,
                    treeID: $scope.treeObj.treeName,
                    chosenTemplates: $scope.treeObj.treeData.chosenTemplates,
                    chosenGroups: $scope.treeObj.treeData.chosenGroups
                });
            });
        };
        // ============================================
        // Archive Portfolio From Existing Portfolio
        // ============================================
        /**
         * Open modal window to archive new portfolio.
         */
        $scope.loadArchivePortfolioFromExistingPortfolio = function (command) {
            setTimeout(function () {
                $scope.$broadcast("manage:" + command.trim(), {
                    acl: $scope.treeObj.treeData.acl,
                    treeID: $scope.treeObj.treeName,
                    nodeID: $scope.treeObj.treeData._id,
                    chosenTemplates: $scope.treeObj.treeData.chosenTemplates,
                    chosenGroups: $scope.treeObj.treeData.chosenGroups
                });
            });
        };
        /**
         * Callback to save new portfolio from existing portfolio.
         */
        $scope.createPortfolioFromExisting = function (newPortfolioName, categoriesConfig, acl, univSchema) {
            var chosenTemplates = $scope.treeObj.treeData.chosenTemplates == undefined ? null : $scope.treeObj.treeData.chosenTemplates;
            var chosenGroups = $scope.treeObj.treeData.chosenGroups == undefined ? null : $scope.treeObj.treeData.chosenGroups;
            $scope.astro.createPortfolioFromExisting(newPortfolioName, categoriesConfig, acl, univSchema, chosenTemplates, chosenGroups)
                .then(function () {
                loadNewTreeAndRefreshPortfolioMenu(newPortfolioName);
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        /**
         * Callback to archive portfolio from existing portfolio.
         */
        $scope.refreshForArchivePortfolio = function (newPortfolioName) {
            $scope.workbenchLoading.start();
            loadNewTreeAndRefreshPortfolioMenu(newPortfolioName);
            $scope.workbenchLoading.end();
        };
        // $scope.archivePortfolioFromExisting = (newPortfolioName: string, readOnly: boolean, categoriesConfig: any, acl: any, univSchema: any) => {
        //     let chosenTemplates = $scope.treeObj.treeData.chosenTemplates == undefined ? null : $scope.treeObj.treeData.chosenTemplates;
        //     let chosenGroups = $scope.treeObj.treeData.chosenGroups == undefined ? null : $scope.treeObj.treeData.chosenGroups;
        //     $scope.showPanels();
        //     smartorgApi.authenticateThroughToken();
        //     let isAdmin = $scope.isAdmin;
        //     $scope.workbenchLoading.start();
        //     if (isAdmin) {
        //         if (!acl.owner) {
        //             acl = {
        //                 "group": {
        //                     "editors": [],
        //                     "portfolioAdmins": [],
        //                     "viewers": []
        //                 },
        //                 "user": {
        //                     "editors": [],
        //                     "portfolioAdmins": [],
        //                     "viewers": []
        //                 }
        //             };
        //         }
        //     }
        //     smartorgApi.archivePortfolio($scope.treeObj.treeData._id, newPortfolioName,
        //         $scope.treeObj.treeData.name, readOnly, acl)
        //         .then(() => {
        //             loadNewTreeAndRefreshPortfolioMenu(newPortfolioName);
        //             $scope.workbenchLoading.end();
        //         }).catch((err: any) => {
        //         let errorMsg = 'Portfolio ' + newPortfolioName + ' already exists.';
        //         if (err.message.indexOf(errorMsg) == -1) {
        //             errorMsg = newPortfolioName + ' cannot be saved.';
        //         }
        //         $scope.showAlert("danger", "Failed!", errorMsg);
        //         $scope.workbenchLoading.end();
        //     });
        // };
        // ============================================
        // Define Category
        // ============================================
        /**
         * Load category from server by tree root Id.
         */
        $scope.loadCategory = function () {
            var treeRootId = $scope.treeObj.treeData._id;
            smartorgApi.categoriesConfigFor(treeRootId).then(function (data) {
                $scope.$broadcast("manage:" + $scope.command.trim(), {
                    "config": data,
                    'treeId': $scope.treeObj.treeName
                });
                $scope.workbenchLoading.end();
                $scope.$apply();
            })["catch"](function (err) {
                if (err.status == 404 &&
                    err.statusText == 'NOT FOUND') {
                    $scope.$broadcast("manage:" + $scope.command.trim(), {
                        "config": "",
                        'treeId': $scope.treeObj.treeName
                    });
                }
                else {
                    $scope.showAlert("danger", "Server Error " + err.status, err.message);
                }
                $scope.workbenchLoading.end();
            });
        };
        /**
         * Update default category filter.
         *
         * @param category {{}} Single category object.
         * @param redirectToAssign {bosolean}
         * @param renameEntriesTracker []
         * @param changedCategoryName {}
         */
        $scope.onUpdateDefaultFilter = function (filterLogic, excludedTags) {
            smartorgApi.setDefaultTreeViewFilters($scope.treeObj.treeName, { filterLogic: filterLogic, excludedTags: excludedTags }).then(function (result) {
                if (result) {
                    console.log("filterLogic api hit");
                    // scope.treeObj.setDefaultTreeViewFilters(filterLogic);
                    // scope.treeObj.filterTree(filterLogic);
                    // scope.treeObj.setDefaultTreeViewExcludeFilters(filterLogic);
                    // scope.treeObj.excludeNodeBy(excludedFilterTags);
                    // shareLink.setTreeFilters(filterLogic);
                    // shareLink.setTreeExcludeFilters(excludedFilterTags);
                    // showAlert('success', 'Success!', 'Set default filters successfully.');
                }
                else {
                    console.log("filterLogic api error");
                    // showAlert('danger', 'Error!', 'Failed to set default filters.');
                }
            })["catch"](function (err) {
                // showAlert('danger', 'Error!', 'Failed to set default filters! See console for more details');
                console.error(err);
            });
        };
        /**
 * Update category tags.
 *
 * @param tags []
 */
        $scope.onUpdateCategory = function (categories) {
            console.log(categories);
            $scope.treeObj.treeData['categoriesConfig'] = categories;
        };
        /**
         * Save category by tree root id.
         *
         * @param category {{}} Single category object.
         * @param redirectToAssign {boolean}
         * @param renameEntriesTracker []
         * @param changedCategoryName {}
         */
        $scope.onSaveCategory = function (category, redirectToAssign, renameEntriesTracker, changedCategoryName, action, index) {
            var treeRootId = $scope.treeObj.treeData._id;
            smartorgApi.saveCategoryConfig(treeRootId, category, renameEntriesTracker, changedCategoryName).then(function () {
                $scope.$broadcast("DefineCategories:onSaveCategorySuccess", {
                    categoryName: category.CategoryName
                });
                if (redirectToAssign) {
                    var cmd = 'DisplayCategoryAssignment';
                    $scope.command = cmd;
                    $scope.showAssignCategory(cmd, category.CategoryName, true);
                }
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        /**
         * Delete a category by name. If there are duplicated
         * names, delete the first one.
         *
         * @param categoryName {string} Category name (as id).
         */
        $scope.onDeleteCategory = function (categoryName) {
            var treeRootId = $scope.treeObj.treeData._id;
            smartorgApi.deleteCategoryConfig(treeRootId, categoryName).then(function () {
                $scope.$broadcast("DefineCategories:onDeleteCategorySuccess", {
                    categoryName: categoryName
                });
                //console.log(result);
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        /**
         * Arrange categories in CategoriesConfig.
         *
         * @param categoriesConfig
         */
        $scope.onArrangeCategories = function (categoriesConfig) {
            var treeRootId = $scope.treeObj.treeData._id;
            smartorgApi.arrangeCategoriesConfig(treeRootId, categoriesConfig).then(function () {
                $scope.treeObj.categoriesConfig = categoriesConfig;
                $scope.$broadcast("DefineCategories:onArrangeCategoriesSuccess", {});
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        // ============================================
        // Assign Category
        // ============================================
        // function showAssignCategory(command: string, categoryName: any = "") {
        //     console.log(command, categoryName);
        //     $scope.workbenchLoading.end();
        //     setTimeout(() => {
        //         $scope.$broadcast("manage:" + command.trim(), {
        //             treeId: $scope.treeObj.treeName,
        //             rightCollapsed: $scope.layoutCollapsed.right,
        //             categoryName: categoryName
        //         });
        //     }, 0);
        // }
        $scope.showAssignCategory = function (command, categoryName, hasChanges) {
            if (hasChanges === void 0) { hasChanges = false; }
            $scope.workbenchLoading.end();
            setTimeout(function () {
                $scope.$broadcast("manage:" + command.trim(), {
                    treeId: $scope.treeObj.treeName,
                    rightCollapsed: $scope.layoutCollapsed.right,
                    categoryName: categoryName,
                    hasChanges: hasChanges
                });
            }, 0);
        };
        // ============================================
        // Report Options
        // ============================================
        /**
         * Load tags and in/outputs ranges for selected tree node.
         *
         * @param treeNodeId {string} Selected tree node id.
         * @param params {{}} Query string info. Undefined means
         *     this is coming from user selecting tree node.
         */
        $scope.initReportOptions = function (treeNodeId, params) { return __awaiter(_this_1, void 0, void 0, function () {
            var optionState;
            return __generator(this, function (_a) {
                optionState = {};
                if ($scope.reportOptionString && $scope.reportOptionString != btoa("{}")) {
                    optionState = JSON.parse(atob($scope.reportOptionString));
                }
                if (params) {
                    if (params["treenode"]) {
                        treeNodeId = decodeURIComponent(params["treenode"]);
                    }
                    if (params["options"]) {
                        optionState = JSON.parse(atob(decodeURIComponent(params["options"])));
                        if (optionState['compareToNodeID']) {
                            $scope.compareNode = $scope.treeObj.nodeMap[optionState['compareToNodeID']];
                            optionState['node'] = $scope.compareNode;
                        }
                    }
                }
                if (treeNodeId && $scope.treeObj.nodeMap[treeNodeId]) {
                    $scope.$broadcast(broadcast_config_1["default"].INIT, {
                        nodeID: treeNodeId,
                        initState: optionState,
                        defaultVal: $scope.defaultReportOptions,
                        isLeaf: $scope.treeObj.nodeMap[treeNodeId].isLeaf(),
                        isAdmin: $scope.isAdmin,
                        categoryConfigs: $scope.treeObj.categoriesConfig,
                        currentFilterLogic: $scope.treeObj.currentFilterLogic,
                        currentExcludedFilterTags: $scope.treeObj.currentExcludedFilterTags
                    });
                }
                return [2 /*return*/];
            });
        }); };
        /**
         * When user click compare to button, turn on/off compare
         * select on tree. When it is on, can select a second node
         * on tree.
         *
         * @param nodeId {string} Current comparing node.
         */
        $scope.onToggleCompare = function (nodeId) {
            if ($scope.treeObj && nodeId) {
                $scope.compareNode = $scope.treeObj.nodeMap[nodeId];
            }
            else {
                $scope.compareNode = undefined;
            }
        };
        /**
         * Get report options string for further access.
         *
         * @param reportOptions {{}} A dict of report options.
         */
        $scope.onApplyReportOptions = function (reportOptions) {
            if (reportOptions && Object.keys(reportOptions).length) {
                if (reportOptions['compareToNodeID']) {
                    var compareToNode = $scope.treeObj.nodeMap[reportOptions['compareToNodeID']];
                    if (compareToNode && $scope.selected) {
                        if ($scope.selected.isLeaf() ^ compareToNode.isLeaf()) {
                            reportOptions['compareToNodeID'] = undefined;
                            reportOptions['compareToNodeName'] = undefined;
                            $scope.$broadcast(broadcast_config_1["default"].COMPARE_CLEAR);
                            $scope.showAlert("warning", "Warning", "Cannot compare portfolio node and leaf node.");
                        }
                    }
                }
                $scope.reportOptionString = btoa(JSON.stringify(reportOptions));
                shareLink.setValue('options', $scope.reportOptionString);
            }
            else {
                $scope.reportOptionString = EMPTY_REPORT_OPTIONS;
                shareLink.clearValue('options');
            }
            $scope.$broadcast("tree:reloadTree", { reportOptionString: $scope.reportOptionString });
        };
        $scope.onApplyOptionsChange = function () {
            $scope.selectMenuItem(undefined, undefined);
        };
        // ============================================
        // Share Shorten URL
        // ============================================
        /**
         * Generate shorten URL from current selected objects.
         * The api will encode the input url, so no need to
         * encode here.
         */
        $scope.generateShortenUrl = function () {
            smartorgApi.createShortURL(shareLink.getInfoString(), false, "").then(function (shortenUrl) {
                var url = "https://" + $location.host() +
                    "/s/" + shortenUrl._id;
                var item = document.getElementById('shareLinkUrl');
                item['value'] = url;
                $("#shareLinkModal").modal('show');
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        $scope.copyShortenUrl = function ($event) {
            var item = document.getElementById('shareLinkUrl');
            item.focus();
            var copied = false;
            try {
                copied = document.execCommand("Copy", false, null);
            }
            catch (ex) {
                console.error(ex);
            }
            if (copied) {
                $event.currentTarget.value = "Link Copied!";
                setTimeout(function () {
                    $event.currentTarget.value = "Copy Link";
                }, 3000);
            }
            else {
                $event.currentTarget.value = "Press Ctrl-C";
            }
        };
        /**
         * Get necessary information from shorten url. The short
         * url provides a key and will be redirect to server with
         * the key.
         *
         * Api will not decode the output, so need a decode here.
         *
         * @param key {string} Corresponding to an entry in db.
         */
        $scope.getInfoFromShorten = function (key) {
            smartorgApi.getInfoForShortURL(key).then(function (result) {
                var info = decodeURIComponent(result.url);
                shareLink.loadItemFromString(info);
                $scope.onSelectPortfolio(undefined, shareLink.item);
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        // ============================================
        // Zendesk Login Support
        // ============================================
        /**
         * Server side will get email/verfication info from database
         * based on username. So this email address will not affect
         * actual zendesk security.
         */
        $scope.getUserEmailInfo = function () {
            $scope.email = undefined;
            smartorgApi.getUserProfile().then(function (result) {
                $scope.email = {
                    email: result['email'],
                    verified: result['email_verified']
                };
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        /**
         * Redirect to zendesk.
         *
         * Window open has a security concern that it can only
         * be trigger legally when directly linked to a user
         * click event.
         *
         * If there is a server request before window open, the
         * browsers will block the pop out window.
         */
        $scope.onZendeskRedirect = function (page) {
            if (!$scope.email || // server error
                !$scope.email.email || !$scope.email.verified) {
                angular.element("#emailModal").modal("show");
                $scope.emailStep = 1;
            }
            else {
                var zenWindow_1 = window.open("", "_blank");
                smartorgApi.zendeskAuthUrl(page).then(function (url) {
                    if (url.indexOf("zendesk") > 0) {
                        zenWindow_1.location.href = url;
                    }
                    else {
                        zenWindow_1.location.href = "404.html";
                    }
                })["catch"](function (err) {
                    $scope.showAlert("danger", "Server Error " + err.status, err.message);
                });
            }
        };
        /**
         * Save email address. Send it to server, generate a
         * verification link and send it through email to user.
         *
         * If the email has been verified (user verify email then)
         * come back to this page without login), click on send
         * email will just skip the sending process.
         *
         * @param email {string} Email address to be send.
         */
        $scope.saveEmailAddress = function (email) {
            smartorgApi.getUserProfile().then(function (result) {
                $scope.email = {
                    email: result['email'],
                    verified: result['email_verified']
                };
                if (!$scope.email.email || !$scope.email.verified) {
                    smartorgApi.updateUserEmail(email).then(function () {
                        $scope.emailStep = 2;
                        $scope.$apply();
                    })["catch"](function (err) {
                        $scope.showAlert("danger", "Server Error " + err.status, err.message);
                    });
                }
                else {
                    $scope.showAlert("info", "Email has been verified", "Your email has already been verified.");
                    angular.element("#emailModal").modal("hide");
                }
            })["catch"](function (err) {
                $scope.showAlert("danger", "Server Error " + err.status, err.message);
            });
        };
        // ============================================
        // Forward broadcast to widgets
        // ============================================
        /**
         * Add saved schema to root node.
         */
        $scope.$on('workbench:reloadroot', function (event, args) {
            var sn = args ? args.schemaName : undefined;
            $scope.reloadRoot(sn);
        });
        /**
         * Forward broadcasting between widgets. Widgets emit commands
         * here with necessary args.
         */
        $scope.$on('workbench:broadcast', function (event, args) {
            $scope.$broadcast(args.command, {
                data: args.data
            });
        });
        $scope.$on('workbench:back', function (event, args) {
            $scope.showPanels();
            $scope.currentTreeColors = undefined;
            if (args && 'currentTreeColors' in args) {
                $scope.currentTreeColors = args.currentTreeColors;
            }
            if (args && args.reload) {
                $scope.onSelectPortfolio(undefined, shareLink.item);
            }
            else {
                $scope.backtoAction();
            }
        });
        $scope.$on('workbench:update_node_category', function (event, args) {
            // console.log($scope.treeObj.nodeMap[args.nodeID])
            // console.log($scope.treeObj.nodeMap[args.nodeTagList])
            var nodeTagsGot = args.nodeTagList[0];
            var tagsGot = nodeTagsGot[1].split(",");
            $scope.treeObj.nodeMap[args.nodeID]['tags'] = tagsGot;
        });
        $scope.$on('workbench:last_updated', function (event, args) {
            $timeout(function () {
                var nodeID = args.nodeID;
                var now = new Date();
                var today = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
                $scope.treeObj['nodeMap'][nodeID]['lastUpdated'] = today;
                // $('#' + nodeID.replace(/\./g, '\\.')).attr('data-content',
                //     'Last updated: ' + today + '<br>' + 'Saved by: ' + $scope.userName);
                if ($scope.showTreeColors) {
                    $scope.treeObj['nodeMap'][nodeID]['leafColor'] = { 'color': '#153a42' };
                }
            });
        });
        $scope.$on('workbench:update_categories', function (event, args) {
            var tagsToBeUpdated = args.data;
            console.log(tagsToBeUpdated);
            var categoryType = args.categoryType || "tags";
            tagsToBeUpdated.forEach(function (tagToBeUpdated) {
                var categoryNames = Object.keys(tagToBeUpdated.categories);
                var allTags = $scope.treeObj['nodeMap'][tagToBeUpdated.nodeID][categoryType];
                var pathIds = $scope.treeObj['nodeMap'][tagToBeUpdated.nodeID]['path'];
                if (categoryType == "tags") {
                    var categoryIsPresent_1 = false;
                    categoryNames.forEach(function (categoryName) {
                        var tag = categoryName + ':' + tagToBeUpdated.categories[categoryName];
                        for (var i = 0; i < allTags.length; i++) {
                            var _a = allTags[i].split(':'), cateName = _a[0], entry = _a[1];
                            if (cateName == categoryName) {
                                categoryIsPresent_1 = true;
                                allTags[i] = tag; // Replace existing when category type is single-select (classification)
                                // TODO: handle multi-select
                                break;
                            }
                        }
                        if (!categoryIsPresent_1) {
                            // Add tag when category is not existing and category type is single-select (classification)
                            allTags.push(tag);
                        }
                        // propagate up the updated tag
                        pathIds.forEach(function (path) {
                            if (!new Set($scope.treeObj['nodeMap'][path]['tags']).has(tag)) {
                                $scope.treeObj['nodeMap'][path]['tags'].push(tag);
                            }
                        });
                    });
                }
                else {
                    categoryNames.forEach(function (categoryName) {
                        var _loop_1 = function (i) {
                            var _a = allTags[i].split(':'), cateKey = _a[0], encodedVal = _a[1], encodedName = _a[2];
                            if (cateKey == categoryName) {
                                var dropdownTag_1 = cateKey + ':' +
                                    encodeURIComponent(btoa(tagToBeUpdated.categories[categoryName])) + ":" + encodedName;
                                allTags[i] = dropdownTag_1; // Replace existing dropdownTag
                                // propagate up the updated tag
                                pathIds.forEach(function (path) {
                                    if (!new Set($scope.treeObj['nodeMap'][path]['dropdownTags']).has(dropdownTag_1)) {
                                        $scope.treeObj['nodeMap'][path]['dropdownTags'].push(dropdownTag_1);
                                    }
                                });
                                return "break";
                            }
                        };
                        for (var i = 0; i < allTags.length; i++) {
                            var state_1 = _loop_1(i);
                            if (state_1 === "break")
                                break;
                        }
                    });
                }
                // Angular copying to itself so the it triggers onChanges in simple-filter-v2.component
                $scope.treeObj.treeData[categoryType] = angular.copy($scope.treeObj.treeData[categoryType]);
            });
        });
        $scope.$on('workbench:update_isDataValid', function (event, args) {
            if ($scope.treeObj.treeData.role === 'a') {
                $timeout(function () {
                    var nodeIdList = args.nodeIdList;
                    var isDataValid = args.isDataValid !== false;
                    for (var _i = 0, nodeIdList_1 = nodeIdList; _i < nodeIdList_1.length; _i++) {
                        var nodeID = nodeIdList_1[_i];
                        var node = $scope.treeObj['nodeMap'][nodeID];
                        node['isDataValid'] = isDataValid;
                        // common data
                        if (node.hasChildren) {
                            var leaves = node.getAllLeaves();
                            for (var _a = 0, leaves_1 = leaves; _a < leaves_1.length; _a++) {
                                var leave = leaves_1[_a];
                                leave['isDataValid'] = isDataValid;
                            }
                        }
                    }
                    $scope.treeObj.updateIsDataValidForAdmin();
                    $scope.$broadcast("recalc_main:refresh", {});
                });
            }
            // only update node lastRecalc if not admin
            if (args.isDataValid !== false) {
                for (var _i = 0, _a = args.nodeIdList; _i < _a.length; _i++) {
                    var nodeID = _a[_i];
                    var node = $scope.treeObj['nodeMap'][nodeID];
                    node['lastRecalc'] = new Date().toISOString();
                }
                $scope.treeObj.updateLastRecalc();
            }
        });
        $scope.$on('workbench:showTreeColors', function (event, args) {
            $scope.showTreeColors = args.showTreeColors;
        });
        $scope.$on('workbench:share', function () {
            $scope.generateShortenUrl();
        });
        $scope.$on('workbench:toggle_panels', function (event, args) {
            for (var i = 0; i < args.panels.length; i++) {
                if (args.show) {
                    $scope.collapsePanel(args.panels[i]);
                }
                else {
                    $scope.expandPanel(args.panels[i]);
                }
            }
        });
        $scope.$on('workbench:update_description', function (event, args) {
            $scope.treeObj.nodeMap[args.nodeID].description =
                btoa(args.description);
        });
        $scope.$on('selectedMenu', function (event, args) {
            $scope.selectedMenuItem = args.node;
        });
        $scope.$on('displayAssignCategories', function (event, args) {
            $scope.command = "DisplayCategoryAssignment";
            var categoryName = undefined;
            if (args.categoryName) {
                categoryName = args.categoryName;
            }
            var hasChanges = args.hasChanges || false;
            $scope.showAssignCategory("DisplayCategoryAssignment", categoryName, hasChanges);
        });
        $scope.$on('displayDefineCategories', function () {
            $scope.command = "DisplayCategoriesDefinition";
            $scope.loadCategory();
        });
        $scope.$on('workbench:modifyNodeMap', function (event, data) {
            data.map(function (_a) {
                var nodeId = _a[0], tagStr = _a[1];
                $scope.treeObj.nodeMap[nodeId].tags = tagStr.split(',');
                $scope.treeObj.nodeMap[nodeId].tagString = tagStr;
            });
            $scope.$broadcast('addNodeModal');
        });
        /**
         * Load the page into certain selected items.
         * Not supporting report options so far.
         */
        $scope.$on('workbench:redirect', function (event, args) {
            // portfolio: undefined,
            // treenode: undefined,
            // menu: undefined,
            // options: undefined
            var startPhase = 5;
            if (args.options) {
                $scope.reportOptionString = args.options || EMPTY_REPORT_OPTIONS;
                shareLink.setValue('options', args.options);
                startPhase = 4;
            }
            if (args.menu) {
                shareLink.setValue('menu', args.menu);
                startPhase = 3;
            }
            if (args.treenode) {
                shareLink.setValue('treenode', args.treenode);
                startPhase = 2;
            }
            if (args.portfolio) {
                shareLink.setValue('portfolio', args.portfolio);
                startPhase = 1;
            }
            switch (startPhase) {
                case 1:
                    $scope.onSelectPortfolio(args.portfolio, shareLink.item);
                    break;
                case 2:
                    $scope.onSelectNodeWithParam(args.treenode, shareLink.item);
                    break;
                case 3:
                case 4:
                    $scope.selectMenuItem(args.menu, shareLink.item);
                    break;
                default:
                    break;
            }
        });
        $scope.reloadAction = function () {
            var portfolioName = $scope.treeObj.treeName;
            if ($scope.selectedMenuItem.Command === 'INPUT_SCREEN') {
                performAction([$scope.selected._id, $scope.selectedMenuItem.menuID, 'INPUT_SCREEN'])
                    .subscribe(handleActionResponse, handleActionError);
                return;
            }
            if (localStorage.getItem('PortfolioConfig') &&
                portfolioName in JSON.parse(localStorage.getItem('PortfolioConfig'))) {
                var portfolioConfig = JSON.parse(localStorage.getItem('PortfolioConfig'))[portfolioName];
                $scope.$broadcast("workspace:reloadAction", { portfolioConfig: portfolioConfig });
            }
            else {
                $scope.astro.getPortfolioConfig(portfolioName)
                    .then(function (portfolioConfig) {
                    setTimeout(function () {
                        $scope.$broadcast("workspace:reloadAction", { portfolioConfig: portfolioConfig });
                    });
                })["catch"](function (err) {
                    $scope.showAlert("danger", "Server Error " + err.status, err.message);
                });
            }
        };
        $scope.$on('workbench:emit', function (event, args) {
            $scope.onSelectAction();
            if ($rootScope.smartorgDirty) {
                var discardChange = confirm("The unsaved data will be lost. Do you want to proceed?");
                if (discardChange) {
                    $rootScope.smartorgDirty = false;
                }
                else {
                    return;
                }
            }
            var command = args.command;
            var oldCommand = $scope.command;
            if (command === 'RecalculatePortfolio') {
                $scope.showAlert('info', 'Recalculation on ' + $scope.treeObj.treeData.name + ' is started.', 'You will be notified when it is done. ' +
                    'Please do not work on this portfolio during the process.');
                setTimeout(function () {
                    smartorgApi.recalculatePortfolio($scope.treeObj.treeData.name).then(function () {
                        $scope.showAlert('success', $scope.treeObj.treeData.name +
                            ' was recalculated successfully.');
                    });
                });
            }
            else if (command == "PortfolioConfiguration") {
                $scope.loadPortfolioConfiguration(command, args.saveGlobally, args.showInputConfig);
            }
            else {
                $scope.command = command;
            }
            if (command == "DisplayCategoriesDefinition") {
                $scope.hidePanels();
                $scope.loadCategory();
            }
            else if (command == "DisplayCategoryAssignment") {
                var categoryName = args.categoryName;
                $scope.hidePanels();
                $scope.showAssignCategory(command, categoryName);
            }
            else if (command == "SaveNewPortfolio") {
                $scope.loadCreatePortfolioModal(command);
            }
            else if (command == "CreatePortfolioFromExisting") {
                $scope.loadCreatePortfolioFromExistingPortfolio(command);
            }
            else if (command == "ArchivePortfolioFromExisting") {
                $scope.loadArchivePortfolioFromExistingPortfolio(command);
            }
            if (command === "ExportPortfolio") {
                $scope.showPanels();
                $scope.onApplyOptionsChange();
                smartorgApi.exportPortfolio($scope.treeObj.treeData._id)
                    .then(function () {
                    $scope.showAlert("success", "Success!", "Exported '" + $scope.treeObj.treeName + "' " +
                        "portfolio successfully");
                })["catch"](function () {
                    $scope.showAlert("danger", "Failed!", "'" + $scope.treeObj.treeName + "' cannot be exported.");
                });
            }
            if (command === "ArchivePortfolio") {
                $scope.showPanels();
                $scope.onApplyOptionsChange();
                smartorgApi.archivePortfolio($scope.treeObj.treeData._id)
                    .then(function () {
                    $scope.showAlert("success", "Success!", "Save '" + $scope.treeObj.treeName + "' " +
                        "portfolio successfully");
                })["catch"](function () {
                    $scope.showAlert("danger", "Failed!", "'" + $scope.treeObj.treeName + "' cannot be exported.");
                });
            }
            if (command === "ApplyChangeReadOnly" || command === "ApplyRename") {
                $scope.command = oldCommand;
                $scope.onApplyOptionsChange();
            }
            if (command === "RenamePortfolio") {
                $scope.command = oldCommand;
                for (var i = 0; i < $scope.portfolioData.length; i++) {
                    var oldname = $scope.treeObj.treeName;
                    var newname = $scope.treeObj.treeData.name;
                    if ($scope.portfolioData[i].text === oldname) {
                        $scope.portfolioData[i].text = newname;
                        $scope.treeObj.treeName = newname;
                    }
                }
                setTimeout(function () {
                    $scope.$apply();
                });
            }
            if (command === "RefreshPortfolios") {
                $scope.command = oldCommand;
                for (var i = 0; i < $scope.portfolioData.length; i++) {
                    if ($scope.treeObj.treeName ===
                        $scope.portfolioData[i].text) {
                        $scope.portfolioData.splice(i, 1);
                    }
                }
            }
            // let manageCommands = [
            //     'ImportPortfolio',
            //     'FetchCalculationEngineLog',
            //     'ADDRESS_BOOK',
            //     'MY_PROFILE',
            //     'GROUP_MANAGEMENT',
            //     'RESTRICT',
            //     'PORTFOLIO_PERMISSIONS',
            //     'LEGAL_MESSAGE:LICENSE',
            //     'LEGAL_MESSAGE:SECURITY_WARNING_WB'
            // ];
            if (command == "ImportPortfolio") {
                $scope.loadImportPortfolio(command);
                $scope.hidePanels();
            }
            if (command == "FetchCalculationEngineLog") {
                $scope.loadCalculationEngineLog(command);
                $scope.hidePanels();
            }
            if (command == "FetchPypeerLog") {
                $scope.loadPypeerLog(command);
                $scope.hidePanels();
            }
            if (command === 'ADDRESS_BOOK') {
                $scope.command = "ADDRESS_BOOK";
                $scope.hidePanels();
            }
            if (command === 'MY_PROFILE') {
                $scope.command = "MY_PROFILE";
                $scope.hidePanels();
                setTimeout(function () {
                    $scope.$apply();
                    $scope.$broadcast('user:MY_PROFILE', {
                        security: true,
                        showBackButton: true
                    });
                });
            }
            if (command === 'GROUP_MANAGEMENT') {
                $scope.command = "GROUP_MANAGEMENT";
                $scope.hidePanels();
                setTimeout(function () {
                    $scope.$apply();
                    $scope.$broadcast('manage:GROUP_INIT');
                });
            }
            if (command === 'DATA_BASE_MANAGE') {
                $scope.command = "DATA_BASE_MANAGE";
                $scope.hidePanels();
                setTimeout(function () {
                    $scope.$apply();
                    $scope.$broadcast(global_tables_component_1.BroadcastKeys.INIT);
                });
            }
            if (command === 'RESTRICT') {
                $scope.command = "RESTRICT";
                $scope.hidePanels();
                setTimeout(function () {
                    $scope.$apply();
                    $scope.$broadcast('manage:RESTRICT', {
                        treeId: $scope.treeObj.treeData.name
                    });
                });
            }
            if (command === 'PORTFOLIO_PERMISSIONS') {
                $scope.command = "PORTFOLIO_PERMISSIONS";
                $scope.hidePanels();
                setTimeout(function () {
                    $scope.$apply();
                    $scope.$broadcast('manage:PORTFOLIO_PERMISSIONS', {
                        treeId: $scope.treeObj.treeData.name
                    });
                });
            }
            if (command === 'LEGAL_MESSAGE:LICENSE' ||
                command === 'LEGAL_MESSAGE:SECURITY_WARNING_WB') {
                var messageType_1 = command.split(':')[1];
                $scope.command = "LEGAL_MESSAGE";
                $scope.hidePanels();
                console.log(messageType_1);
                setTimeout(function () {
                    $scope.$apply();
                    $scope.$broadcast('manage:LEGAL_MESSAGE', {
                        messageType: messageType_1
                    });
                });
            }
            if (command === 'BROADCAST_MESSAGE_MANAGE') {
                $scope.command = "BROADCAST_MESSAGE_MANAGE";
                $scope.hidePanels();
                $timeout(function () {
                    $scope.$broadcast('manage:BROADCAST_MESSAGE_MANAGE');
                });
            }
            $timeout(function () {
                $scope.workbenchLoading.end();
            });
        });
        // ============================================
        // Close alert on clicking anywhere on page
        // ============================================
        $scope.showNetworkErrorMsg = function (error) {
            var alertDiv = $("#workbenchNetworkAlert");
            if (!error) {
                error = {};
                $scope.networkError = {};
                alertDiv.hide();
                // Return here to prevent loading spinner end early.
                return;
            }
            $scope.networkError = {
                'message': error.message
            };
            if (error.message) {
                alertDiv.show();
                var additionalMsgSpan_1 = $('#networkErrorAdditionMsg');
                if (error.timeout) {
                    var countdown_1 = error.timeout - 1;
                    additionalMsgSpan_1.text(" Retry in " + (countdown_1--) + " seconds");
                    var x_1 = setInterval(function () {
                        additionalMsgSpan_1.text(" Retry in " + (countdown_1--) + " seconds");
                        if (countdown_1 < 0) {
                            clearInterval(x_1);
                            additionalMsgSpan_1.text("Retrying... ");
                        }
                    }, 1000);
                }
                else {
                    additionalMsgSpan_1.text("");
                }
            }
            else {
                alertDiv.hide();
            }
            $scope.workbenchLoading.end();
        };
        smartorgApi.onNetworkError(function (error) {
            $scope.showNetworkErrorMsg(error);
        });
        /**
         * Show a bootstrap style alert.
         *
         * @param type {string} Can be success, info, warning, danger.
         * @param title {string} Title on the alert.
         * @param message {string} Detail message.
         */
        $scope.showAlert = function (type, title, message) {
            $scope.alertType = type.toLowerCase();
            $scope.messageTitle = title;
            $scope.messageBody = message;
            console.log($scope.alertType);
            console.log($scope.messageTitle);
            console.log($scope.messageBody);
            if (!$scope.$$phase) {
                $scope.$apply();
            }
            var alertbox = $("#workbenchAlert");
            alertbox.fadeTo(0, 1);
            alertbox.alert();
            setTimeout(function () {
                if ($scope.alertType == type.toLowerCase() &&
                    $scope.messageTitle == title &&
                    $scope.messageBody == message) {
                    var alertbox_1 = $("#workbenchAlert");
                    alertbox_1.slideUp(500, function () {
                        $scope.alertType = "";
                    });
                }
            }, 10000);
        };
        $scope.hideAlert = function () {
            var alertbox = $("#workbenchAlert");
            alertbox.slideUp(500, function () {
                $scope.alertType = "";
            });
        };
        $scope.$on('workbench:alert', function (event, args) {
            $scope.showAlert(args.type, args.title, args.message);
        });
        $scope.$on('updateImpactTypeInSelected', function (event, args) {
            $scope.selected['inavImpactType'] = args.inavImpactType;
        });
        $scope.$on(broadcast_config_1["default"].SET_DEFAULT, function (event, args) {
            var reportOptions = args.reportOptions;
            var portfolioName = $scope.treeObj.treeName;
            sendDefaultReportOptionsAndTreeFilters(reportOptions, { 'filterLogic': $scope.treeObj.defaultTreeViewFilters });
            smartorgApi.setDefaultReportOptions(portfolioName, reportOptions).then(function (result) {
                if (result) {
                    $scope.defaultReportOptions = reportOptions;
                    $scope.showAlert('success', 'Success!', 'Set default report options successfully!');
                }
                else {
                    $scope.showAlert('danger', 'Error!', 'Failed to set default report options!');
                }
            })["catch"](function (err) {
                $scope.showAlert('danger', 'Error!', 'Failed to set default report options!');
                console.error(err);
            });
        });
        // ============================================
        // Handle the loading spinner
        // ============================================
        $scope.workbenchLoading = {
            showSpinner: false,
            start: function () {
                $scope.workbenchLoading.showSpinner = true;
                $timeout();
            },
            end: function () {
                $scope.workbenchLoading.showSpinner = false;
                $timeout();
            }
        };
        $scope.$on('workbench:loading', function (event, args) {
            if (args.load) {
                $scope.workbenchLoading.start();
            }
            else {
                $scope.workbenchLoading.end();
            }
        });
        $scope.$on('workbench:reloadAction', function () {
            var _a = $scope.currentAction, nodeId = _a[0], menuId = _a[1], command = _a[2];
            if (nodeId && menuId && command) {
                $scope.onSelectAction(nodeId, menuId, command);
            }
        });
        // ============================================
        // Listen to Logout
        // ============================================
        $scope.$on('workbench:logout', function () {
            logoutWorkbench();
        });
        // ============================================
        // When 1st time loading the workbench
        // ============================================
        smartorgApi.authenticateThroughToken().then(function (userInfo) {
            $scope.userName = userInfo.username;
            $scope.isAdmin = userInfo.is_admin;
            $scope.astro.protocols.credentials = {
                username: userInfo.username,
                isAdmin: userInfo.is_admin
            };
            $scope.showLogout = true;
            smartorgApi.getServerConfig().then(function (response) {
                if (response.defaultAuth === 'AZURE') {
                    $scope.showLogout = false;
                }
                if (response.richTextBox) {
                    localStorage.setItem('richTextBox', response.richTextBox.toString());
                }
                $scope.isInav = response.isInav;
                $scope.tagsPropagateUp = response.tagsPropagateUp;
                $scope.calcEngineAccess = response.calcEngineAccess || false;
                $scope.userPortfolioAccess = response.userPortfolioAccess || false;
                $scope.isCorteva = response.isCorteva;
                $scope.lazyArchive = response.lazyArchive || false;
                $scope.excludeTags = response.excludeTags || false;
                $scope.filtersOnBackend = response.filtersOnBackend || false;
                $scope.showTutorial = !response.disableTutorial || false;
                $scope.zendeskToggle = response.zendeskToggle || false;
                $scope.downloadModelToggle = response.downloadModelToggle || false;
                // making sure to remove the filters from session if excludeTags key is true
                if (response.excludeTags) {
                    shareLink.clearTreeFilters();
                    shareLink.clearTreeExcludeFilters();
                }
            })["catch"](function (err) {
                console.error(err);
            });
            /**
             * Load user email. Must place after declaring the function.
             *
             * Uncomment this line when zendesk server side is merged in.
             */
            $scope.getUserEmailInfo();
            $scope.loadPortfolio();
            $timeout(function () {
                if ($location.search() && $location.search()['s']) {
                    $scope.getInfoFromShorten($location.search()['s']);
                    $location.search('s', null);
                }
                else if (localStorage.getItem('shortUrl')) {
                    var shortUrl = localStorage.getItem('shortUrl');
                    localStorage.removeItem('shortUrl');
                    $scope.getInfoFromShorten(shortUrl);
                }
                else {
                    shareLink.loadItem();
                    $scope.onSelectPortfolio(undefined, shareLink.item);
                }
            });
        })["catch"](function (err) {
            console.error(err);
            $location.path('/login');
            $timeout();
        });
    }
]);
module.exports = 'smartorg.r6.views.workbench';
//# sourceMappingURL=workbench.js.map


// WEBPACK FOOTER //
// ./app/views/workbench/app/js/plumbing/workbench.js